/**
 * Types d'évènement portés par le `data` d'une notification push.
 *
 * Le serveur envoie un type et des identifiants d'objets ; il ne connaît pas nos
 * écrans. La correspondance type → route est la responsabilité du front, et vit
 * dans `NotificationRouteGuard` (#173).
 */
export enum NotificationTypeEnum {
    /** Connexion bancaire interrompue chez l'agrégateur */
    BridgeItemDisconnected = 'bridge_item_disconnected',
    /** Mandat d'authentification forte d'une connexion bancaire bientôt expiré (J-15, J-7, J-1) */
    BridgeItemAuthExpiring = 'bridge_item_auth_expiring',
    /** Demande de reconnexion d'un compte bancaire adressée à son contact */
    BankAccountSyncRequest = 'bank_account_sync_request',
    /** Import d'un relevé bancaire au format CSV terminé */
    BankCsvImport = 'bank_csv_import',
    /** Nouveau message, ou mention, dans une conversation */
    ConversationNewMessage = 'conversation_new_message',
}
